// src/store/authStore.ts
import { create } from 'zustand';
import { User } from '../types';

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  setUser: (user: User) => void;
  setToken: (token: string) => void;
  logout: () => void;
  loadUser: () => void;
}

const getStoredUser = (): User | null => {
  const stored = localStorage.getItem('user');
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch {
      return null;
    }
  }
  return null;
};

export const useAuthStore = create<AuthState>((set) => ({
  user: getStoredUser(),
  token: localStorage.getItem('token'),
  isAuthenticated: !!localStorage.getItem('token'),

  setUser: (user) => {
    // Ensuring updated_at is stored for cache busting
    const userWithTimestamp = {
      ...user,
      updated_at: user.updated_at || new Date().toISOString(),
    };
    localStorage.setItem('user', JSON.stringify(userWithTimestamp));
    if (user?.role?.name) {
      localStorage.setItem('user_role', user.role.name);
    }
    set({ user: userWithTimestamp, isAuthenticated: true });
  },

  setToken: (token) => {
    localStorage.setItem('token', token);
    set({ token, isAuthenticated: true });
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('user_role');
    set({ user: null, token: null, isAuthenticated: false });
  },

  loadUser: () => {
    const user = getStoredUser();
    const token = localStorage.getItem('token');
    if (token && user) {
      set({ user, token, isAuthenticated: true });
    }
  },
}));
